module.exports = __webpack_public_path__ + "static/media/pamain-extrabold.640b5620.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-extrabold.ttf
// module id = ./src/assets/fonts/pamain-extrabold.ttf
// module chunks = 0